export enum EStoreStatus {
  CREATED = 'created',
  ACTIVE = 'active',
  REQUIRES_RECONNECTION = 'requires_reconnection',
  FETCHING_PRODUCTS = 'fetching_products',
  DELETED = 'deleted',
  INACTIVE = 'inactive',
}
